module.exports = __webpack_public_path__ + "media/servicios2.0076c368.mp4";